import axios from "axios";

const win: any = window;
const errorPage = win["errorPageURL"];

const apigeeConfig = {
  api: {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'x-transaction-id': '3124235347568',
      channel: "PORTAL",
    },
  },
}

export const apigeeSimpleApi = axios.create();
export const apigeeApi = axios.create({ ...apigeeConfig.api });

apigeeApi.defaults.validateStatus = function () {
  return true;
};

apigeeApi.interceptors.request.use(
  async (conf: any) => {
    const apigeeToken = win["apigeeClientToken"];

    conf.baseURL = win["base_api_url"];
    conf.headers.Authorization = `Bearer ${apigeeToken}`;
    conf.headers['cem-key'] = window.location.origin.includes('localhost') ? "liCENcCCGpHUsEPHNhySYGXCnmhwzZ" : win["CEM_KEY"];

    return conf;
  }, (err) => {
    console.log("error in getting ", err);
  }
);

apigeeApi.interceptors.response.use(async (response: any) => {
  return response;
},
  async (error: any) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);

const getAccountDetails = async (number: string) => {
  const apigeeBaseURL = win["base_api_url"];
  const url = `${apigeeBaseURL}/SiebelInquiry/v1?CommercialID=${number}`;

  return apigeeApi.get(url)
}

export { getAccountDetails };
